import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Opportunity } from '@vendasta/sales-opportunities';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { CreateOpportunityService } from '../../sales-opportunities/opportunity-side-panel/create-opportunity/create-opportunity.service';
import { CreateOpportunityPageData } from '../../sales-opportunities/opportunity-side-panel/create-opportunity/interface';
import { OpportunityDetailsService } from '../../sales-opportunities/opportunity-side-panel/opportunity-details/opportunity-details.service';
import { OpportunitySidePanelEventsService } from '../../sales-opportunities/opportunity-side-panel/opportunity-side-panel-events.service';
import { OpportunityService } from '../../sales-opportunities/opportunity.service';
import {
  SidePanelState,
  SidePanelStateData,
  SidePanelStateService,
} from '../../slide-out-panel/side-panel-state.service';
import { SlideOutPanelService } from '../../slide-out-panel/slide-out-panel.service';

@Component({
  selector: 'sales-ui-pipeline-side-panel',
  templateUrl: './pipeline-side-panel.component.html',
  styleUrls: ['./pipeline-side-panel.component.scss'],
})
export class PipelineSidePanelComponent {
  readonly sidePanelState$: Observable<SidePanelStateData<Opportunity>>;
  readonly SidePanelState = SidePanelState;
  opportunity$: Observable<Opportunity>;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly sidePanelState: SidePanelStateService,
    private readonly slideOutPanelService: SlideOutPanelService,
    private readonly opportunityUpdates: OpportunityService,
    private readonly detailsSlideOut: OpportunityDetailsService,
    private readonly createOpportunityService: CreateOpportunityService,
    private readonly sidePanelEvents: OpportunitySidePanelEventsService,
  ) {
    this.sidePanelState$ = this.sidePanelState.sidePanelState$.pipe(
      startWith(<SidePanelStateData<any>>{ state: SidePanelState.opportunityDetails, data: undefined }),
    );
    this.opportunity$ = this.opportunityUpdates.currentOpportunity$;

    const formData = {
      sourceLocation: 'pipeline',
    } as CreateOpportunityPageData;
    this.createOpportunityService.setCreatePageDetails(formData);

    this.sidePanelEvents.opportunityCreatedEvents$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.scrollToTop();
    });
    this.sidePanelEvents.sidePanelCloseEvents$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.slideOutPanelService.closeSlideOut();
      this.scrollToTop();
    });
  }

  private scrollToTop(): void {
    document?.getElementById('top-of-sidepanel')?.scrollIntoView({ behavior: 'smooth' });
  }
}
